"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'CarpacTable',
  props: {
    tab: {
      type: String,
      default: ''
    },
    regionOptions: {
      type: Array,
      default: function _default() {
        return [];
      },
      require: true
    },
    rimList: {
      type: Array,
      default: function _default() {
        return [];
      },
      require: true
    }
  },
  data: function data() {
    return {
      regionObj: null,
      // 省选中项
      cityObj: null,
      // 市选中项
      cityOptions: [],
      // 市
      sourceApi: null,
      listLoading: false,
      rimSize: '',
      // 规格
      rim: '',
      list: [],
      total: 0,
      currPage: 1,
      limit: 20
    };
  },
  mounted: function mounted() {
    // this.fetchTableList()
  },
  methods: {
    provinceChange: function provinceChange(valObj) {
      this.cityOptions = valObj.children;
      this.cityObj = null;
    },
    resetTableList: function resetTableList() {
      // 清空筛选
      this.regionObj = null;
      this.cityObj = null;
      this.cityOptions = [];
      this.list = [];
      if (this.tab !== 'carpacTab1') {
        this.rimSize = '';
        this.rim = '';
        // 重置页码
        this.currPage = 1;
        this.limit = 20;
        this.total = 0;
      }
      // 发起请求
      // this.fetchTableList()
    },
    queryFetch: function queryFetch() {
      // 重置页码
      this.currPage = 1;
      // 发起请求
      this.fetchTableList();
    },
    fetchTableList: function fetchTableList() {
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      if (this.tab === 'carpacTab1') {
        this.fetch_regionCarpList(this.sourceApi.token);
      } else if (this.tab === 'carpacTab2') {
        this.fetch_rimCarpList(this.sourceApi.token);
      } else if (this.tab === 'carpacTab3') {
        this.fetch_brandCarpList(this.sourceApi.token);
      } else {
        console.log('inValid tab name');
      }
    },
    fetch_regionCarpList: function fetch_regionCarpList(cancleToken) {
      var _this = this;
      var param_tab1 = {
        region: this.regionObj ? this.regionObj.label : '',
        city: this.cityObj ? this.cityObj.label : ''
      };
      if (!param_tab1.region || !param_tab1.city) {
        this.$message.error(this.$t('sfe.reportModule.error.region'));
        return;
      }
      this.listLoading = true;
      this.$api.reportModule.carpac_regionCarpList(param_tab1, cancleToken).then(function (res) {
        _this.listLoading = false;
        _this.list = [(0, _objectSpread2.default)({}, res.data)];
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this.listLoading = false;
      });
    },
    fetch_rimCarpList: function fetch_rimCarpList(cancleToken) {
      var _this2 = this;
      // 规格搜索内容不能少于5位
      if (this.rimSize && this.rimSize.length < 5) {
        this.$message.error(this.$t('sfe.reportModule.error.rimSize'));
        return;
      }
      var param = this.getAllParams();
      if (!param.smodel.region || !param.smodel.city) {
        this.$message.error(this.$t('sfe.reportModule.error.region'));
        return;
      }
      this.listLoading = true;
      this.$api.reportModule.carpac_rimCarpList(param, cancleToken).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items || [];
        _this2.total = res.data.totalCount || 0;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    fetch_brandCarpList: function fetch_brandCarpList(cancleToken) {
      var _this3 = this;
      var param = this.getAllParams();
      if (!param.smodel.region || !param.smodel.city) {
        this.$message.error(this.$t('sfe.reportModule.error.region'));
        return;
      }
      this.listLoading = true;
      this.$api.reportModule.carpac_brandCarpList(param, cancleToken).then(function (res) {
        _this3.listLoading = false;
        _this3.list = res.data.items || [];
        _this3.total = res.data.totalCount || 0;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this3.listLoading = false;
      });
    },
    getAllParams: function getAllParams() {
      return {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          region: this.regionObj ? this.regionObj.label : '',
          city: this.cityObj ? this.cityObj.label : '',
          rimSize: this.rimSize,
          rim: this.rim ? parseInt(this.rim) : null
        }
      };
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    }
  }
};